import { render, staticRenderFns } from "./AssetGroups.vue?vue&type=template&id=282abfd1&"
import script from "./AssetGroups.vue?vue&type=script&lang=js&"
export * from "./AssetGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports